import { Feature } from '@tencent/workbench';
import BaseDrawerFeature from '@framework/workbench/common/feature/base-drawer-feature';
import { checkIsSlideBg } from '@framework/workbench/drawer/utils';

@Feature()
export class BackgroundFeature extends BaseDrawerFeature {
    public get curModelIsLayout(): boolean {
        return !!this.getSelectionService().currentSlide?.isLayout;
    }

    public get curModelIsSlide(): boolean {
        return !!this.getSelectionService().currentSlide?.isSlide;
    }

    public getShowMasterSp(): boolean {
        return !!this.getSelectionService().currentSlide?.showMasterSp;
    }

    public get isSlideBg(): boolean {
        return checkIsSlideBg(this.getPropertyMenu()?.items);
    }
}
